import { render, staticRenderFns } from "./reviseTemplate.vue?vue&type=template&id=a0cb5c64&scoped=true&"
import script from "./reviseTemplate.vue?vue&type=script&lang=js&"
export * from "./reviseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./reviseTemplate.vue?vue&type=style&index=0&id=a0cb5c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cb5c64",
  null
  
)

export default component.exports